import { createFileRoute, Outlet } from '@tanstack/react-router';

import { safeCheckIsAuth } from '#modules/user/features/auth/utils/checkIsAuth';
import { DashboardLayout } from '#modules/user/features/dashboard/components/DashboardLayout';
import { ErrorNotFound } from '#features/error/components/ErrorNotFound';

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard')({
  loader: async () => {
    const { isAuth, status } = await safeCheckIsAuth();

    return { isAuth, authStatus: status };
  },
  // Resolve the auth guard before sending the dashboard shell; UI stays client-rendered.
  ssr: 'data-only',
  // Кабинет не для выдачи. Закрывать его в robots.txt нельзя: Google тогда не видит этот
  // noindex и держит голые адреса /dashboard/* в индексе по внешним ссылкам из писем.
  head: () => ({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] }),
  component: LayoutComponent,
  notFoundComponent: ErrorNotFound,
});

/**
 * ReCaptchaProvider здесь намеренно нет: капча нужна ровно трём страницам дашборда
 * (`settings/security`, `feedback`, `players/$playerId` - там репорт из меню профиля), и каждая
 * монтирует провайдер сама. На уровне лейаута скрипт Google висел на всех страницах разом,
 * включая чаты, а его токен живёт две минуты — протухнув, он кидал `reCAPTCHA Timeout (b)`
 * необработанным реджектом в людей, которые просто переписывались.
 */
function LayoutComponent() {
  const { isAuth } = Route.useLoaderData();

  return (
    <DashboardLayout isAuth={isAuth}>
      <Outlet />
    </DashboardLayout>
  );
}
